import { render, staticRenderFns } from "./subscriptions-management-container.vue?vue&type=template&id=9815fda8&scoped=true&lang=pug"
import script from "./subscriptions-management-container.js?vue&type=script&lang=js&external"
export * from "./subscriptions-management-container.js?vue&type=script&lang=js&external"
import style0 from "./subscriptions-management-container.vue?vue&type=style&index=0&id=9815fda8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9815fda8",
  null
  
)

export default component.exports